import { useId } from 'react';

/**
 * The "Co-ed" gender chip — blue gradient square with "COED".
 * Colors are baked in by design (Figma Gender component, variant "Co-ed").
 */
export default function GenderCoed({ className }: { className?: string }) {
  const uid = useId().replace(/:/g, '');
  const gradientId = `gender-coed-gradient-${uid}`;

  return (
    <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          id={gradientId}
          x1="16"
          y1="2"
          x2="16"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4A7BE0" />
          <stop offset="1" stopColor="#3F70D6" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="28" height="28" rx="3.6" fill={`url(#${gradientId})`} />
      <svg
        x="7.226"
        y="6.666"
        width="8.083"
        height="18.669"
        viewBox="0 0 6.06279 14.0001"
        fill="none"
      >
        <path
          fill="#FFFFFF"
          d="M6.06279 2.51353H4.28185C4.26922 2.36617 4.23553 2.2325 4.1808 2.1125C4.12817 1.99251 4.05449 1.88936 3.95976 1.80305C3.86714 1.71463 3.75451 1.64727 3.62189 1.60096C3.48926 1.55254 3.33875 1.52833 3.17034 1.52833C2.87562 1.52833 2.62616 1.5999 2.42196 1.74305C2.21987 1.8862 2.06619 2.09145 1.96093 2.35881C1.85778 2.62616 1.80621 2.94719 1.80621 3.32191C1.80621 3.71767 1.85884 4.04923 1.96409 4.31658C2.07145 4.58183 2.22618 4.78182 2.42827 4.91655C2.63037 5.04917 2.87351 5.11548 3.1577 5.11548C3.3198 5.11548 3.46505 5.09548 3.59347 5.05549C3.72188 5.01338 3.83345 4.95339 3.92818 4.8755C4.02292 4.79761 4.09975 4.70393 4.1587 4.59446C4.21975 4.48289 4.2608 4.35763 4.28185 4.21869L6.06279 4.23132C6.04174 4.50499 5.9649 4.78392 5.83228 5.06812C5.69966 5.3502 5.51125 5.61124 5.26705 5.85123C5.02496 6.08911 4.72498 6.28067 4.36711 6.42593C4.00923 6.57118 3.59347 6.64381 3.11981 6.64381C2.52616 6.64381 1.99356 6.51645 1.52201 6.26173C1.05257 6.00701 0.681012 5.63229 0.407344 5.13759C0.135781 4.64288 0 4.03765 0 3.32191C0 2.60195 0.138939 1.99567 0.416817 1.50307C0.694695 1.00836 1.06941 0.634699 1.54096 0.382082C2.01251 0.127361 2.53879 0 3.11981 0C3.52821 0 3.90398 0.0557861 4.24711 0.167358C4.59025 0.278931 4.89128 0.442079 5.15022 0.656802C5.40915 0.869421 5.61756 1.13151 5.77544 1.44307C5.93333 1.75463 6.02911 2.11145 6.06279 2.51353Z"
        />
        <path
          fill="#FFFFFF"
          d="M0.700879 14.0001V7.53309H5.36165V8.94775H2.45656V10.0593H5.12167V11.4739H2.45656V12.5854H5.34902V14.0001H0.700879Z"
        />
      </svg>
      <svg
        x="15.978"
        y="6.666"
        width="8.797"
        height="18.669"
        viewBox="0 0 6.59853 14.0001"
        fill="none"
      >
        <path
          fill="#FFFFFF"
          d="M6.59853 3.32196C6.59853 4.04191 6.45854 4.64924 6.17855 5.14395C5.89857 5.63655 5.5207 6.01022 5.04494 6.26494C4.56918 6.51755 4.03868 6.64386 3.45346 6.64386C2.86402 6.64386 2.33142 6.5165 1.85566 6.26178C1.382 6.00495 1.00518 5.63024 0.725199 5.13764C0.447321 4.64293 0.308382 4.0377 0.308382 3.32196C0.308382 2.602 0.447321 1.99572 0.725199 1.50312C1.00518 1.00841 1.382 0.634749 1.85566 0.382133C2.33142 0.127411 2.86402 5.05447e-05 3.45346 5.05447e-05C4.03868 5.05447e-05 4.56918 0.127411 5.04494 0.382133C5.5207 0.634749 5.89857 1.00841 6.17855 1.50312C6.45854 1.99572 6.59853 2.602 6.59853 3.32196ZM4.79232 3.32196C4.79232 2.93461 4.74075 2.60831 4.63759 2.34307C4.53655 2.07572 4.38603 1.87362 4.18604 1.73679C3.98816 1.59785 3.74396 1.52838 3.45346 1.52838C3.16295 1.52838 2.9177 1.59785 2.71771 1.73679C2.51983 1.87362 2.36931 2.07572 2.26616 2.34307C2.16511 2.60831 2.11459 2.93461 2.11459 3.32196C2.11459 3.7093 2.16511 4.03665 2.26616 4.304C2.36931 4.56925 2.51983 4.77134 2.71771 4.91028C2.9177 5.04712 3.16295 5.11553 3.45346 5.11553C3.74396 5.11553 3.98816 5.04712 4.18604 4.91028C4.38603 4.77134 4.53655 4.56925 4.63759 4.304C4.74075 4.03665 4.79232 3.7093 4.79232 3.32196Z"
        />
        <path
          fill="#FFFFFF"
          d="M3.3776 14.0001H0.88933V7.53309H3.35234C4.01756 7.53309 4.59226 7.66256 5.07645 7.92149C5.56273 8.17832 5.93745 8.54882 6.20059 9.033C6.46584 9.51508 6.59846 10.0929 6.59846 10.7666C6.59846 11.4402 6.46689 12.0191 6.20375 12.5033C5.9406 12.9854 5.568 13.3559 5.08592 13.6148C4.60384 13.8717 4.0344 14.0001 3.3776 14.0001ZM2.64501 12.5096H3.31445C3.63443 12.5096 3.90704 12.4581 4.13229 12.3549C4.35965 12.2518 4.53227 12.0739 4.65016 11.8213C4.77015 11.5686 4.83015 11.2171 4.83015 10.7666C4.83015 10.3161 4.7691 9.96453 4.647 9.71191C4.52701 9.45929 4.35017 9.28141 4.1165 9.17826C3.88494 9.07511 3.60075 9.02353 3.26392 9.02353H2.64501V12.5096Z"
        />
      </svg>
    </svg>
  );
}
